import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import TopNav from 'components/TopNav';
import Typography from '@material-ui/core/Typography';
import ImageGridList from 'components/ImageGridList';
import styles from '../styles.module.scss';
// import { CircularProgress } from '@material-ui/core';
import { useQueryClient } from 'react-query';
// import { getLocalStorage } from '../../../utils/utils';
// import { SEARCH_USER_TRIAL_FILTER } from '../../../config/constants';
import * as searchApi from 'api/search';
import qs from 'query-string';
import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';


function SearchTrialResult(props) {
  const history = useHistory();
  const queryClient = useQueryClient();
  const userSearchList = props?.dUsers || []; /// Default page view source
  const message = props?.message || ''; /// Default page view source
  // const rawUserSearchList = queryClient.getQueryData('userSearchList');
  // const rawMessage = queryClient.getQueryData('userSearchListMessage');
  // const rawMessageErr = queryClient.getQueryData('jobSearchJobListMessageErr');


  // useEffect(() => {
  //   if (!Array.isArray(rawUserSearchList) || (Array.isArray(rawUserSearchList) && !rawUserSearchList.length)) {
  //     const fetchUserSearch = async () => {
  //       const dataRaw = await getLocalStorage(SEARCH_USER_TRIAL_FILTER);
  //       let data = {};
  //       if (dataRaw) {
  //         try {
  //           data = JSON.parse(dataRaw);
  //         } catch (e) {
  //           console.error(e);
  //         }
  //       }
  //
  //       const { data: userSearchList, message } = await searchApi.searchUserTrial(data);
  //       setUserSearchList(userSearchList);
  //       if (!userSearchList.length) {
  //         setMessage(message);
  //       }
  //     };
  //
  //     fetchUserSearch();
  //   } else {
  //     setUserSearchList(rawUserSearchList);
  //     if (!rawUserSearchList.length) {
  //       setMessage(rawMessageErr);
  //     }
  //   }
  // }, [rawUserSearchList]);

  const cardList = () => {
    return (
      <ImageGridList
        checked={true}
        cards={userSearchList}
        selectCardFunc={(card) => {
          selectCard(card);
        }}
      />
    );
  };

  const selectCard = (card) => {
    history.push({ pathname: `${process.env.RAZZLE_PUBLIC_URL}/register-trial` });
  };

  return (
    <div style={{ overflow: 'auto', height: '100vh' }}>
      <div className={styles.searchScreen}>
        <TopNav name={'ユーザー検索（お試しリスト）'} hasBackIcon={true} />
        <div style={{ marginTop: 65, marginBottom: 60 }} className={'search-user-trial-result-wrapper'}>
          {isEmpty(userSearchList) ? (
            <React.Fragment>
              <center style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}} >
                <Typography variant="h6" className="font-2">
                  {message}
                </Typography>
              </center>
            </React.Fragment>
          ) : (
            <ImageGridList
              checked={true}
              cards={userSearchList}
              selectCardFunc={(card) => {
                selectCard(card);
              }}
            />
          )}
        </div>
      </div>

      <div className="d-btn-back-search">
        <Link className="btn btn-main"
              variant="contained"
              style={{
                borderRadius: 30,
                padding: '5px 20px',
                height: 'unset',
                width: 'unset',
                textDecoration: 'unset',
              }}
              to={`${process.env.RAZZLE_PUBLIC_URL}/search-user-trial`}>
          検索条件を変えて再検索
        </Link>
      </div>
    </div>
  );
}

SearchTrialResult.getInitialProps = async ({
                                             req, res, match, history, location, ...ctx
                                           }) => {

  const data = typeof window !== 'undefined' ? qs.parse(location?.search) : req?.query;
  const params = data || {};

  if (params?.age_from) {
    params.age_from = +params?.age_from;
  }
  if (params?.age_to) {
    params.age_to = +params?.age_to;
  }

  if (params?.avatar === 'null' || params?.avatar === 'undefined') {
    params.avatar = null;
  }

  if (params?.gender === 'true') {
    params.gender = true;
  }
  if (params?.gender === 'false') {
    params.gender = false;
  }

  if (params?.profiles) {
    let profiles = {};
    try {
      profiles = JSON.parse(params?.profiles);
    } catch (e) {
      profiles = {};
    }

    params.profiles = profiles;
  }
  if (!params?.states || params?.states === 'null') {
    delete params.states;
  } else {
    let states = [];
    try {
      states = JSON.parse(params?.states);
    } catch (e) {
      states = [];
    }

    params.states = states;
  }

  delete params[''];

  const dUsers = await searchApi.searchUserTrial(params);

  return {
    qQuery: params,
    dUsers: (dUsers?.data || []).map(e => {

      return pick(e, ['id', 'label', 'nickName', 'birthday', 'charaStatus', 'states', 'avatar', 'gender', 'standBy']);
    }),
    message: dUsers?.message || '',
  };
};

export default SearchTrialResult;
